import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router";
import DataTable from "../../../components/Common/DataTable/DataTable";
import {
  getRecentlyAddedProgramsSeriesMgmtActionHandler,
  updateProgramActionHandler,
  getAllProgramsCountOrganizeWithoutConditionActionHandler,
} from "../../../store/actions/actionHandlers/organizeActionHandler";
import { seriesManagement } from "../../../utils/mainTabs/organize/seriesManagement";
import { useFetchData } from "../../../hooks/useFetchData";
import { useCheckList } from "../../../hooks/useCheckList";
import { setErrorHandler } from "../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../utils/errorTypes";
import classes from "./SeriesManagement.module.scss";
import AddIcon from "../../../components/Common/SvgIcons/AddIcon";
import { addSeriesMgmt } from "../../../utils/mainTabs/organize/addSeriesMgmt";
import SeriesMgmtTable from "./SeriesMgmtTable/SeriesMgmtTable";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

const SeriesManagement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const routerParams = useLocation();
  const [programCount, setProgramCount] = useState();
  const [filterBySearch, setFilterBySearch] = useState();
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const {
    groupTopicTiles,
    setGroupTopicTiles,
    seriesMgmtTiles,
    createNewSeriesPath,
    tenantName,
  } = useOutletContext();

  // useEffect(() => {
  //   dispatch(
  //     getAllProgramsCountOrganizeWithoutConditionActionHandler(
  //       "Published",
  //       "Program",
  //       setFilterBySearch,
  //       setProgramCount
  //     )
  //   );
  // }, [dispatch]);

  return location.pathname === seriesManagement.path(tenantName) ? (
    <div className={classes.seriesMainDiv}>
      <div className={classes.addSeriesClick}>
        <div
          onClick={() =>
            navigate(
              `${addSeriesMgmt.path(location, routerParams, tenantName)}`
            )
          }
          className={classes.text}
        >
          <AddIcon fill={colors.theme} />
        </div>
        <span
          onClick={() =>
            navigate(
              `${addSeriesMgmt.path(location, routerParams, tenantName)}`
            )
          }
          className={classes.text}
        >
          <FormattedMessage id="ADDNEWPROGRAM_TEXT" />
        </span>
      </div>
      <SeriesMgmtTable />
    </div>
  ) : (
    <Outlet
      context={{
        programCount,
        setProgramCount,
        groupTopicTiles,
        setGroupTopicTiles,
        seriesMgmtTiles,
        createNewSeriesPath,
        tenantName,
      }}
    />
  );
};

export default SeriesManagement;
